import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { menuLayoutRoute } from 'root/MenuLayout';

const pricingSettingsMainRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  path: 'pricing-settings',
  component: lazyRouteComponent(() => import('./PricingSettingsView')),
});

const priceIndexSearchParamsSchema = z.object({
  v2: z.boolean().optional(),
});

export const priceIndexView = createRoute({
  getParentRoute: () => pricingSettingsMainRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./PriceIndexView/PriceIndexView')),
  validateSearch: priceIndexSearchParamsSchema.parse,
});

const basePricingView = createRoute({
  getParentRoute: () => pricingSettingsMainRoute,
  path: 'base-pricing',
  component: lazyRouteComponent(() => import('./BasePricingView/BasePricingView')),
});

const capsAndFloorsView = createRoute({
  getParentRoute: () => pricingSettingsMainRoute,
  path: 'caps-and-floors',
  component: lazyRouteComponent(() => import('./CapsAndFloorsView/CapsAndFloorsView')),
});

const priceEndingsView = createRoute({
  getParentRoute: () => pricingSettingsMainRoute,
  path: 'price-endings',
  component: lazyRouteComponent(() => import('./PriceEndingsView/PriceEndingsView')),
});

const CompetitorsSettingsView = createRoute({
  getParentRoute: () => pricingSettingsMainRoute,
  path: 'competitors',
  component: lazyRouteComponent(() => import('./CompetitorsSettingsView/CompetitorsSettingsView')),
});

export const pricingSettingsRouteTree = pricingSettingsMainRoute.addChildren([
  priceIndexView,
  basePricingView,
  capsAndFloorsView,
  priceEndingsView,
  CompetitorsSettingsView,
]);
